import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { BusinessLookupComponent } from './business-lookup/business-lookup.component';
import { TypeaheadComponent } from '../home/typeahead/typeahead.component';

@NgModule({
  declarations: [BusinessLookupComponent, TypeaheadComponent],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    RouterModule
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    BusinessLookupComponent,
    TypeaheadComponent
  ]
})
export class BusinessLookupModule { }
